import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/icon-font/iconfont.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import router from './router/index.js'
// import pinia from './stores/index.js'
import * as Pinia from 'pinia'
import print from 'vue3-print-nb'
import App from './App.vue'

const app = createApp(App)

app.config.errorHandler = (err, instance, info) => {
  // 处理错误，例如：报告给一个服务
  console.log(err,instance,info)
}

app.use(router)
	.use(print)
	.use(Pinia.createPinia())
	.use(ElementPlus, { locale: zhCn })
	.mount('#app')
